import React, { lazy, Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@reducers/index';
import Header from '@components/template/layout/header';
import LoaderComponent from '@components/atom/layout/loader';

const LeftMenu = lazy(() => import('@components/template/layout/leftMenu'));

const LayoutWrapper = () => {
  const { isLeftMenu, isMobileSearch } = useSelector(({ LAYOUT }: RootState) => LAYOUT);
  return (
    <div id="wrap">
      <div className={`left-content  ${isLeftMenu ? 'active' : ''}`}>
        <Suspense fallback={<LoaderComponent />}>
          <LeftMenu />
        </Suspense>
      </div>

      <div className="main-content">
        <header className={`header ${isMobileSearch ? 'search-on' : ''}`}>
          <Header />
        </header>
        <div className={`container`}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LayoutWrapper;
